import { render } from "./EcoTransportOut.vue?vue&type=template&id=0fdee332&scoped=true"
import script from "./EcoTransportOut.vue?vue&type=script&lang=js"
export * from "./EcoTransportOut.vue?vue&type=script&lang=js"

import "./EcoTransportOut.vue?vue&type=style&index=0&id=0fdee332&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdee332"]])

export default __exports__